export default __webpack_public_path__ + "static/media/body-section-back.ced10070.png";